module.exports = __webpack_public_path__ + "img/48717f4.jpg";